const axios = require('axios');

import {
	serverUrl,
	create_campaign_serverUrl,
	presighnedUrl,
	environment
} from '../properties'
const dataUrl = serverUrl;
const env = environment
const create_campaign_dataUrl = create_campaign_serverUrl;

export default {
	namespaced: true,
	state: {
		campaignList: [],
		campaignGroupFilterList: [],
		campaignGroupList: [],
		isCampaignNameExist: false,
		campaignToAddToGroupList: [],
		campaignSelectedList:[],
		selectedCAmpaignGroupName : '',
		advanceFilter : {},
		prestigeAdvanceFilter:{},
		appliedFilters:[],
		activityList:[],
		keyWordToTagList: [],
		actionSelectionControl: false,
		actionSelectioncampaignGroupControl: false,
		campaignGroupSelectedList:[],
		currentCampaignPath:'',
		selectedAssociateFilter:'All',
		prestigeProfileId:1088518656334420,
		getUntagged:false,
		dspTagList:[]

	},
	mutations: {

		updateCampaignList: (state, data) => {
			state.campaignList = data
		},
		updateCampaignGroupFilterList: (state, data) => {
			state.campaignGroupFilterList = data
		},
		updateCampaignGroupList: (state, data) => {
			state.campaignGroupList = data
		},
		setSelectedCampaignGroupName: (state, data) => {
			state.selectedCAmpaignGroupName = data
		},
		setadvanceFilterAttributes: (state, data) => {
				state.advanceFilter = data
		},
		setPrestigeAdvanceFilterAttributes: (state, data) => {
			state.prestigeAdvanceFilter = data
		},
		setAppliedFilers: (state, data) => {
			state.appliedFilters = data
		},
		SetActivityList: (state, data) => {
			state.activityList = data
		},
		updatePathForCampaign: (state, data) => {
			state.currentCampaignPath = data
		},
	},
	getters: {

	},
	actions: {
		getCampaignGroupList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				if( !payload || !payload.doNotShowSpinner ){
					commit('showLoadingSpinner', null, {
						root: true
					})
				}

				let url = dataUrl + '/campaignGroup/list'

				axios({
					url: url,
					method: 'POST',
					data: {
						q: (payload && payload.q) || rootState.searchFilterString,
						ams_profile_id: rootState.selectedBrandProfle,
						campaign_group_id: rootGetters.getSelectedCampaignGroupFilter,
						resultsPerPage: sessionStorage.getItem("campaignGroup:showPerPage"),
						pageNumber: rootGetters.getCurrentPageNumber,
						vendor_id: rootState.selectedVendorFilter,
						sort: rootState.selectedSortOrder,
						go_client_id: payload && payload.go_client_id?payload.go_client_id:(rootState.clientData?rootState.clientData.client_id:'')
						//orderBy: sessionStorage.getItem("campaignGroup:selectedSortOrder")
					},
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response && response.data) {
						commit('updateCampaignGroupList', response.data.data)
						if (payload && payload.callback) {
							payload.callback(response.data.data);
						}
						commit('updateTotalCampaignAndProductCount',response.data.campaigngroupcount, {
							root: true
						})
						if( !payload || !payload.doNotShowSpinner ){
							commit('hideLoadingSpinner', null, {
								root: true
							})
						}
						resolve(response.data.data)

					}

				}).catch((error) => {
					if( !payload || !payload.doNotShowSpinner ){
						commit('hideLoadingSpinner', null, {
							root: true
						})
					}
					console.log(error.response);
				})
			})
		},
		getCampaignList: ({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) => {
			return new Promise((resolve, reject) => {

				if( !payload || !payload.doNotShowSpinner ){
					commit('showLoadingSpinner', null, {
						root: true
					})
				}

				let searchString = (payload && payload.q) ? payload.q : (payload && payload.selecteCampaignGropuId ? '' :rootState.searchFilterString)

				let vendor_id = '';
				let campaignGroupId = '';

				if(rootGetters.getSelectedVendorFilter == []){
					vendor_id = ""
				}
				else if(rootGetters.getSelectedVendorFilter && rootGetters.getSelectedVendorFilter.length && rootGetters.getSelectedVendorFilter[0].name && rootGetters.getSelectedVendorFilter[0].id){
					vendor_id = rootGetters.getSelectedVendorFilter[0].id

				}
				else if(rootGetters.getSelectedVendorFilter && rootGetters.getSelectedVendorFilter.name && rootGetters.getSelectedVendorFilter.id){
					vendor_id = rootGetters.getSelectedVendorFilter.id

				}
				else{
					vendor_id = rootGetters.getSelectedVendorFilter
				}

				if(rootState.selectedCampaignGroupFilter && rootState.selectedCampaignGroupFilter.id && rootState.selectedCampaignGroupFilter.name){
					campaignGroupId = rootState.selectedCampaignGroupFilter.id;
				}
				else{
					campaignGroupId = rootState.selectedCampaignGroupFilter;
				}

				let data = {
					q: searchString,
					ams_profile_id: rootState.selectedBrandProfle,
					campaign_group_id: campaignGroupId,
					resultsPerPage: sessionStorage.getItem("campaign:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					//orderBy: sessionStorage.getItem("campaign:selectedSortOrder"),
					sort: rootState.selectedSortOrder,
					vendor_id: vendor_id,
					campaign_type: (state.advanceFilter && state.advanceFilter.campaign_type ?state. advanceFilter.campaign_type : ""),
					state:(state.advanceFilter && state.advanceFilter.state ? state.advanceFilter.state : ""),
					status:(state.advanceFilter && state.advanceFilter.status ? state.advanceFilter.status : ""),
					tag:rootGetters.getSelectedTag
				}
				if(rootState.isUserPrestige){
					data.brand_tag = (state.prestigeAdvanceFilter && state.prestigeAdvanceFilter.brand_tag ? state.prestigeAdvanceFilter.brand_tag : "")
					data.strategy_tag=(state.prestigeAdvanceFilter && state.prestigeAdvanceFilter.strategy_tag ? state.prestigeAdvanceFilter.strategy_tag : "")
					data.country_tag=(state.prestigeAdvanceFilter && state.prestigeAdvanceFilter.country_tag ? state.prestigeAdvanceFilter.country_tag : "")
					data.segment_tag=(state.prestigeAdvanceFilter && state.prestigeAdvanceFilter.segment_tag ? state.prestigeAdvanceFilter.segment_tag : "")
					data.tag=(state.prestigeAdvanceFilter && state.prestigeAdvanceFilter.untagged ? state.prestigeAdvanceFilter.untagged : "")
				}
				if (payload && payload.vendorId) {
					data.vendor_id = payload.vendorId;
				}
				if (payload && payload.selecteCampaignGropuId) {
					data.campaign_group_id = payload.selecteCampaignGropuId;
				}
				if (payload && payload.ams_profile_id) {
					data.ams_profile_id = payload.ams_profile_id;
				}
				if(payload && payload.ignoreAmsProfileId){
					data.ams_profile_id = ""
				}

				if(state.currentCampaignPath == 'campaignListPerGroup'){
					data.q=""
					data.ams_profile_id = ''
				}



				// if(payload && payload.tag){
				// 	data.tag =  payload.tag
				// }

				let listCall = 'list';
				if(rootState.isUserPrestige){
					listCall='prestigeList';
					data.ams_profile_id = state.prestigeProfileId
				}
				if(state.getUntagged){
					data.tag="untagged"
				}
				//to get filter specific campaign even if the user has entered through the untagged link
				if(data.brand_tag || data.strategy_tag || data.country_tag || data.segment_tag){
					data.tag="";
				}
				axios({
					url: dataUrl + '/campaign/'+listCall,
					method: 'POST',
					data: JSON.stringify(data),
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response && response.data) {
						commit('updateCampaignList', response.data.data)

						commit('updateTotalCampaignAndProductCount',response.data.campaignTotalCount, {
							root: true
						})
						//to get untagged even after client comes back through another tab
						// state.getUntagged=false;
						commit('updatePathForCampaign', '')

						if(response.data.campaign_group){
							commit('setSelectedCampaignGroupName', response.data.campaign_group)
						}
						if( !payload || !payload.doNotShowSpinner ){
							commit('hideLoadingSpinner', null, {
								root: true
							})
						}
					}
					resolve(response.data);
				}).catch((error) => {
					console.log(error)
					if( !payload || !payload.doNotShowSpinner ){
						commit('hideLoadingSpinner', null, {
							root: true
						})
					}
					reject(error)

				})
			});

		},
		getCampaignGroupFilterList: ({
			commit,
			state,
			rootState,
			rootGetters
		}, payload) => {
			//    const doNotActivateSpinner = data.doNotActivateSpinner;
			//    delete data.doNotActivateSpinner;
			//    console.log('Get All CampaignGroup Call')
			// if(!doNotActivateSpinner){
			//     commit('showLoadingSpinner', null, {
			//         root: true
			//     })
			// }
			return new Promise((resolve, reject) => {
				//    let url='http://localhost:3000/campaignGroup/list'
				let vendor_id = '';
				if(rootGetters.getSelectedVendorFilter && rootGetters.getSelectedVendorFilter.name && rootGetters.getSelectedVendorFilter.id){
					 vendor_id = rootGetters.getSelectedVendorFilter.id
				}
				else{
					vendor_id= rootGetters.getSelectedVendorFilter
				}
			//	let vendor_id = rootGetters.selectedVendorFilter;
				if (payload && payload.vendor_id) {
					vendor_id = payload.vendor_id;
				}
				let ams_profile_id = rootState.selectedBrandProfle;
				if (payload && payload.ams_profile_id) {
					ams_profile_id = payload.ams_profile_id;
				}

				if(payload && payload.fromBrand && payload.brand_id){
					ams_profile_id = payload.brand_id
				}

				axios({
					//  uri : url,
					url: dataUrl + '/campaignGroup/list',
					method: 'POST',
					data: {
						ams_profile_id,
						resultsPerPage: 1000,
						profile: 'basic',
						vendor_id : vendor_id
					},
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if(payload && payload.isOrphan){
						response.data.data.push({name:'ORPHAN',id:1})
					}
					commit('updateCampaignGroupFilterList', response.data.data)
					commit('hideLoadingSpinner', null, {
						root: true
					})
					resolve(response.data.data)
					console.log(response.data.data)
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, {
						root: true
					})
					console.log(error);
					reject(error)

				})
			})
		},
		checkExistingCampaignName: ({
			commit,
			state,
			rootGetters
		}, payload) => {

			commit('showLoadingSpinner', null, {
				root: true
			})
			axios({
				url: dataUrl + '/campaign/findByName',
				method: 'POST',
				data: payload.data,
				headers: rootGetters.fetchHeader,
				responseType: 'json'
			}).then((response) => {
				commit('hideLoadingSpinner', null, {
					root: true
				})
				if (response.data) {
					if (payload.callback) {
						payload.callback(response.data);
					}
				}
			}).catch((error) => {
				console.log(error)
				commit('hideLoadingSpinner', null, {
					root: true
				})
			})
		},
		checkDuplicacyByName: ({
			commit,
			state
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaignGroup/findByName',
					method: 'POST',
					headers: {},
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		fetchBrandByClient: ({
			commit,
			state
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaignGroup/getProfileForClient',
					method: 'POST',
					headers: {},
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		importKeywordFromProduct: ({
			commit,
			state
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaign/keywords',
					method: 'POST',
					headers: {},
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		fetchAmsCampaignId: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				if(env != 'PROD'){
					payload.ams_profile_id = '223797863198027';
					payload.targeting_type = 'auto';
			//		payload.start_date_ams = '20201112'
				}
			//	let headers = rootGetters.fetchHeader
				// let header = rootGetters.fetchHeader;
				// header["Access-Control-Allow-Origin"] = "*";
				// header["Cache-Control"] = "no-cache";
				// header["Access-Control-Allow-Credentials"] = "true";
				// header["Access-Control-Allow-Methods"] = "GET,HEAD,OPTIONS,POST,PUT,DELETE";
				// header["Access-Control-Allow-Headers"] = "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers";
				let url = create_campaign_dataUrl + '/create-ams-campaign'
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if(response && response.data){
						resolve(response.data)
						console.log(response.data);
					}
					else{
						resolve(response)
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},

		saveAmsCampaignId: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaign/setAmS',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
					console.log(response);
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getCampTagList: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaign/listTags',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getPrestigeTagList: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaign/getPrestigeTags',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		saveKeywordWithCampaignId: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: dataUrl + '/keyword/add',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		saveNewCampaign: ({
			commit,
			state,
			rootGetters
		}, payload) => {

			commit('showLoadingSpinner', null, {
				root: true
			})
			payload.data.userName = JSON.parse(window.localStorage.session).name;

			axios({
				url: dataUrl + '/campaign/addUpdate',
				method: 'POST',
				headers: rootGetters.fetchHeader,
				data: payload.data,
				responseType: 'json'
			}).then((response) => {
				if (response) {
					commit('addNewProductToList', payload.data)
					if (payload.callback) {
						payload.callback(response.data);
					}
					//	window.localStorage.setItem("campaign:selectedCampaignGroupFilter",response.data.campaignGroup)


					if(payload && payload.data && payload.data.showBrand){
						commit('setCampaignGroupFilter', response.data.campaignGroup, {
							root: true
						})
						commit('setSelectedBrandProfile', response.data.ams_profile_id, {
							root: true
						})
					}
					// commit('setSelectedVendorFilter', response.data.vendor_id, {
					// 	root: true
					// })
				}
				commit('hideLoadingSpinner', null, {
					root: true
				})
			}).catch((error) => {
				commit('hideLoadingSpinner', null, {
					root: true
				})
			})
		},
		getCampaignById: ({
			commit,
			state,
			rootState,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				var showLoadingSpinner = true;
				if (payload) {
					showLoadingSpinner = !payload.hideLoadingSpinner;
					delete payload.hideLoadingSpinner;
				}
				if (showLoadingSpinner) {
					commit('showLoadingSpinner', null, {
						root: true
					})
				}
				let endpoint = 'get';
				if(rootState.isUserPrestige){
					endpoint = 'getPrestige'
				}
				axios({
					url: dataUrl + '/campaign/'+endpoint,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data[0])
						if (payload.callback) {
							payload.callback(response.data);
						}
					}

					if (showLoadingSpinner) {
						commit('hideLoadingSpinner', null, {
							root: true
						})
					}
				}).catch((error) => {
					console.log(error)
					if (showLoadingSpinner) {
						commit('hideLoadingSpinner', null, {
							root: true
						})
					}
				})
			})
		},
		// addProductsToCampaign: ({commit, state}, payload) => {
		//     rp({
		//         uri: dataUrl +'/product/add/campaign',
		//         method: 'POST',
		//         headers: {},
		//         body: payload.data,
		//         json: true
		//     }).then((response) => {
		//         if (response && response.created) {
		//             if (payload.callback) {
		//                 payload.callback();
		//             }
		//         }
		//     }).catch((error) => {
		//         console.log(error)
		//     })
		// },
		removeProductsFromCampaign: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: dataUrl + '/product/removeCampign',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload.data,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data)
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fetchKeywordList: ({
			commit,
			state,
			rootGetters,
			rootState
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.pageNumber = rootGetters.getKeywordCurrentPageNumber,
				payload.resultsPerPage = sessionStorage.getItem("keyword:keywordShowPerPage"),
				axios({
					url: dataUrl + '/keyword/list',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						commit('updateTotalKeywordCount', response.data.count,{
							root:true
						})
						commit('updateKeywordList',response.data.data,{
							root: true
						})
						resolve(response.data.data)
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fetchSDKeywordList: ({
			commit,
			state,
			rootGetters,
			rootState
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.pageNumber = rootGetters.getKeywordCurrentPageNumber,
				payload.resultsPerPage = sessionStorage.getItem("keyword:keywordShowPerPage"),
				axios({
					// url: dataUrl + '/keyword/getSponseredDisplay',
					url: dataUrl + '/keyword/keywordList',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						commit('updateTotalKeywordCount', response.data.count,{
							root:true
						})
						commit('updateKeywordList',response.data.data,{
							root: true
						})
						resolve(response.data)
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fetchSyncKeywordList: ({
			commit,
			state,
			rootGetters,
			rootState
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.pageNumber = rootGetters.getKeywordCurrentPageNumber,
				payload.resultsPerPage = sessionStorage.getItem("keyword:keywordShowPerPage"),
				axios({
					// url: dataUrl + '/keyword/syncedList',
					url: dataUrl + '/keyword/keywordList',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						commit('updateTotalKeywordCount', response.data.count,{
							root:true
						})
						commit('updateKeywordList',response.data.data,{
							root: true
						})
						resolve(response.data.data)
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fetchKeywordStrategyList: ({
			commit,
			state,
			rootGetters,
			rootState
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/keyword/strategyList',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data.data)
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		fetchKeywordBidsList: ({
			commit,
			state,
			rootGetters,
			rootState
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/keyword/bidsList',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data)
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		deleteCampaignGroup: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaignGroup/del',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
					
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		editCampaignFromCampaignGroup: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: dataUrl + '/campaignGroup/addUpdate',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log("After Res");
					resolve(response.data)
					if(payload.vendorId){
					commit('setSelectedVendorFilter', payload.vendor_id, {
						root: true
					})}
					//window.localStorage.setItem("campaign:",payload.vendor_id);
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		addCampaignToCampaignGroups: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url: dataUrl + '/campaign/addDelGroup',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})

		},
		addAndUpdateCampaignGroup: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: dataUrl + '/campaignGroup/addUpdate',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
					//		commit('setCampaignGroupFilter',payload.vendor_id)
				}).catch((error) => {
					console.log(error);
				})
			})

		},
		addProductsToCampaign: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: dataUrl + '/campaignGroup/addUpdate',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log("After res");
					resolve(response.data);
					console.log(response.data);
				}).catch((error) => {
					console.log(error);
				})
			})

			// rp({
			// 	uri: dataUrl +'/product/addCampaign',
			// 	method: 'POST',
			// 	headers: {},
			// 	body: payload.data,
			// 	json: true
			// }).then((response) => {
			// 	if (response) {
			// 		if (payload.callback) {
			// 			payload.callback();
			// 		}
			// 	}
			// }).catch((error) => {
			// 	console.log(error)
			// })
		},
		getCampaignGroupById: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {

				axios({
					url: dataUrl + '/campaignGroup/get',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {

					resolve(response.data);

				}).catch((error) => {
					console.log(error);
				})
			})
		},
		editProductsOfCampaign: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			payload.userName = JSON.parse(window.localStorage.session).name;

			axios({
				url: dataUrl + '/campaignGroup/addUpdate',
				method: 'POST',
				headers: rootGetters.fetchHeader,
				data: payload,
				responseType: 'json'
			}).then((response) => {
				console.log(response.data);
			}).catch((error) => {
				console.log(error);
			})
		},
		deleteCampaign: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url: dataUrl + '/campaign/del',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		updateMNSOStatus: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url: dataUrl + '/campaignGroup/msoFlag',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		deleteItemFromBudgetItem: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: dataUrl + '/campaignGroup/delBudget',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getActivityDataList:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				axios({
					url:dataUrl+'/campaign/getLoggedAction',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					if(response.data && response.data.data){
						commit("SetActivityList", response.data.data)
					}
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		addCampaignToProduct: ({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url: dataUrl + '/product/addCampaign',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		getPresighnedURL: ({
			commit,
			state,
			rootGetters
		}) => {
			return new Promise((resolve, reject) => {
				let data = {
					"contentType": "text/csv",
					"ext": "csv"
				}
				let url = dataUrl + '/keyword/getBucketUrl'
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: data
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		uploadFile:({
			commit,
			state,
			rootGetters
		}, payload) => {
			return new Promise((resolve, reject) => {
				axios({
					url: payload.url,
					method: 'PUT',
					headers: rootGetters.fetchHeader,
					data: payload.data,
					headers: {'Content-Type': 'text/csv'},
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		addRecommendedKeyword:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/keyword/sample',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		addExactKeyword:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/keyword/addSearchTermKeyword',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getRecommendedKeywords:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.pageNumber = rootGetters.getRecommendedKeywordCurrentPageNumber,
				payload.resultsPerPage = sessionStorage.getItem("keyword:recommendedKeywordShowPerPage")||25,
				axios({
					url:dataUrl+'/keyword/getRecommendedKeywords',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					if(response && response.data){
						commit('updateRecommendedKeywordList',response.data.data,{root:true})
						commit('updateRecommendedTotalKeywordCount',response.data.count,{root:true})
					}
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getExactKeywords:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.pageNumber = rootGetters.getRecommendedKeywordCurrentPageNumber
				payload.resultsPerPage = sessionStorage.getItem("keyword:recommendedKeywordShowPerPage")
				axios({
					url:dataUrl+'/keyword/getKeywordSearchList',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					if(response && response.data){
						commit('updateRecommendedKeywordList',response.data.data,{root:true})
						commit('updateRecommendedTotalKeywordCount',response.data.count,{root:true})
					}
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getexactKeywordHistory:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				axios({
					url:dataUrl+'/keyword/getKeywordHistory',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getKeywordGroupList:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				axios({
					url:dataUrl+'/keyword/groupList',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		saveNewKeyWordGroup:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/keyword/group',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		saveBulkTag:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/campaign/bulkTag',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		savePrestigeBulkTag:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/campaign/prestigeBulkTag',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getTagsForKeyword:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				axios({
					url:dataUrl+'/keyword/getTags',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		saveKeywordTags:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/keyword/tags',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					resolve(response.data)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getKeywordForTag:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				axios({
					url:dataUrl+'/keyword/getKeyordForTag',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					if(response.data && response.data.data){
						commit('updateTotalKeywordCount', response.data.count,{
							root:true
						})
						commit('updateKeywordList',response.data.data,{
							root: true
						})
						resolve(response.data.data)


					}
					else{
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		editKeywordBid:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url:dataUrl+'/keyword/editManual',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					if(response.data && response.data.data){
						resolve(response.data.data)
					}
					else{
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		switchOffKeyword:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url:dataUrl+'/keyword/switchBid',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					if(response.data && response.data.data){
						resolve(response.data.data)
					}
					else{
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		delTagForKeyword:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;

				axios({
					url:dataUrl+'/keyword/delTag',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					if(response.data && response.data.data){
						resolve(response.data.data)
					}
					else{
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getTagsForAKeyword:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{

				axios({
					url:dataUrl+'/keyword/getTagForAKeyword',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					if(response.data && response.data.data){
						resolve(response.data.data)
					}
					else{
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		delMutipleTgsForAKeyword:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{

				axios({
					url:dataUrl+'/keyword/delTagForMultipleKeyword',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{

					if(response.data && response.data.data){
						resolve(response.data.data)
					}
					else{
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		sendMailForNoAms:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{

				axios({
					url:dataUrl+'/campaign/noAMSMail',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					resolve(response)
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		bulkMinMaxBidUpdate:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/keyword/bulkAddEditMinMaxBid',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					if(response.data){
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		minMaxBidUpdate:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{
				payload.userName = JSON.parse(window.localStorage.session).name;
				axios({
					url:dataUrl+'/keyword/addEditMinMaxBid',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					if(response.data){
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
		getKeywordDescDetails:({
			commit,
			state,
			rootState,
			rootGetters
		},payload) => {
			return new Promise((resolve,reject) =>{

				axios({
					url:dataUrl+'/keyword/getRecRecord',
					method:'POST',
					data:payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) =>{
					if(response.data){
						commit('updateTotalKeywordDescCount', response.data.count,{
							root:true
						})
						commit('updateKeywordDescList',response.data.data,{
							root: true
						})
						resolve(response.data)
					}
				}).catch((error)=>{
					reject(error)
				})
			})
		},
	}
}
